import Joi from 'joi';
import { objectSchemaOf } from '../helpers';

export interface ITakeSnapshotParams {
  conversationId: string;
  consoleId: string;
}

export const takeSnapshotParamsSchema = objectSchemaOf<ITakeSnapshotParams>({
  conversationId: Joi.string().required(),
  consoleId: Joi.string().required(),
});
